/**
 * Created by ferasmasood on 9/18/17.
 */
(function (app) {
    app.factory('CareerPortalDataBus', ["$q", function ($q) {
        var tree = {};
        var basicInfo = {};
        var entrpriseDetails = {};
        var jobs = {};
        var brandLevelId ;
        var CareerPortalDataBus = {};

        CareerPortalDataBus.setBrandsTree = function (newTree) {
            tree = newTree;
        };

        CareerPortalDataBus.getBrandsTree = function() {
            return angular.copy(tree);
        };

        CareerPortalDataBus.getSubTree = function(path) {
            var tmp = angular.copy(tree);
            for (index in path) {
                tmp = (tmp) ?  tmp[path[index]] : null;
            }
            return tmp;
        };

        CareerPortalDataBus.setBasicInfo = function (newBasicInfo) {
            if (newBasicInfo?.career_portal_simple_view_image?.media_secondary) {
                newBasicInfo.career_portal_simple_view_image.media_secondary.sort((a, b) => a.order - b.order);
            }
            basicInfo = newBasicInfo
        };

        CareerPortalDataBus.getBasicInfo = function() {
            return angular.copy(basicInfo);
        };

        CareerPortalDataBus.setEntrpriseDetails = function (newEntrpriseDetails) {
            entrpriseDetails = newEntrpriseDetails
        };

        CareerPortalDataBus.getEntrpriseDetails = function() {
            return angular.copy(entrpriseDetails);
        };

        CareerPortalDataBus.setJobs = function (newJobs) {
            jobs = newJobs
        };

        CareerPortalDataBus.getJobs = function() {
            return angular.copy(jobs);
        };

        CareerPortalDataBus.setBrandLevelId = function (newBrandLevelId) {
            brandLevelId = parseInt(newBrandLevelId);
        };

        CareerPortalDataBus.getBrandLevelId = function() {
            return brandLevelId;
        };

        return CareerPortalDataBus;
    }]);

})(angular.module('harriApp'));

